import React from 'react';
import Login from '../../Components/Login';
import './LoginPage.css';

const LoginPage = () => {
	return (
		<main className='loginPage'>
			<div className='loginPage__Image'>
				<div className='loginPage__Illustration' aria-hidden='true'>
					<div className='loginPage__Card loginPage__Card--primary' />
					<div className='loginPage__Card loginPage__Card--secondary' />
					<div className='loginPage__Orb loginPage__Orb--blue' />
					<div className='loginPage__Orb loginPage__Orb--green' />
				</div>
			</div>
			<div className='loginPage__Login'>
				<Login />
			</div>
		</main>
	);
};

export default LoginPage;
